import type { Components } from '@mui/material/styles';

export default function MUIStep(): Components['MuiStep'] {
  return {};
}
